import React, { useState } from 'react';

const teamMembers = [
{
  name: 'Erik Nordmann',
  role: 'Grunnlegger & CEO',
  bio: 'Tidligere ingeniør hos Statens vegvesen med 15 års erfaring innen veisystemer og digital infrastruktur. Grunnla NordPass i 2019 etter å ha sett behovet for bedre digitale verktøy for norske sjåfører.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_17eb76ada-1772191888904.png",
  alt: 'Professional portrait of Erik Nordmann, CEO, confident man in his 40s with Norwegian fjord background',
  tag: 'OSLO'
},
{
  name: 'Astrid Bergström',
  role: 'CTO & Medgrunnlegger',
  bio: 'Doktorgrad i geoinformatikk fra NTNU. Leder teknologiutviklingen med fokus på sanntids kartdata og maskinlæring for trafikkprediksjoner.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1515be289-1772191889904.png",
  alt: 'Professional portrait of Astrid Bergström, CTO, woman with dark hair against Norwegian mountain landscape',
  tag: 'TRONDHEIM'
},
{
  name: 'Lars Fjeldheim',
  role: 'Head of Design',
  bio: 'Utdannet ved Kunsthøgskolen i Oslo. Bringer norsk designtradisjon inn i digital produktutvikling med fokus på brukervennlighet og estetikk.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_171d2be8c-1763292051641.png",
  alt: 'Professional portrait of Lars Fjeldheim, Head of Design, creative man with beard in studio setting',
  tag: 'BERGEN'
},
{
  name: 'Ingrid Solberg',
  role: 'Head of Data',
  bio: 'Tidligere forsker ved Meteorologisk institutt. Ansvarlig for NordPass sin dataplattform og integrasjoner med offentlige vegdatabaser.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_16567411f-1763294952544.png",
  alt: 'Professional portrait of Ingrid Solberg, Head of Data, woman with blonde hair in professional setting',
  tag: 'STAVANGER'
},
{
  name: 'Bjørn Haugen',
  role: 'Lead Engineer',
  bio: 'Full-stack ingeniør med bakgrunn fra Telenor og Finn.no. Bygger skalerbar infrastruktur som håndterer millioner av daglige forespørsler.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1ed3efff5-1763294227970.png",
  alt: 'Professional portrait of Bjørn Haugen, Lead Engineer, focused man with glasses in tech environment',
  tag: 'OSLO'
},
{
  name: 'Marte Dahl',
  role: 'Customer Success',
  bio: 'Leder kundeservice og brukeropplæring. Sikrer at alle NordPass-brukere får maksimalt utbytte av plattformen.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_13340b3e3-1772191889888.png",
  alt: 'Professional portrait of Marte Dahl, Customer Success Manager, friendly woman with warm smile',
  tag: 'OSLO'
}];


const TeamSection = () => {
  const [expanded, setExpanded] = useState(null);

  return (
    <section style={{ background: '#080E1A', padding: '120px 0', position: 'relative' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '80px' }}>
          <div>
            <div style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#3B6FD4',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              marginBottom: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
              TEAMET
            </div>
            <h2 style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(2rem, 4vw, 3.5rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              letterSpacing: '-0.04em',
              lineHeight: 1,
              margin: 0
            }}>
              MENNESKENE
              <br /><span style={{ color: '#3B6FD4' }}>BAK</span> KARTET
            </h2>
          </div>
          <div style={{
            fontFamily: 'Lora, serif',
            fontStyle: 'italic',
            fontSize: '1rem',
            color: 'rgba(138,149,163,0.6)',
            maxWidth: '300px',
            textAlign: 'right'
          }}>
            Et dedikert team spredt over Norges byer, samlet om én visjon.
          </div>
        </div>

        {/* Team grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2px' }}>
          {teamMembers?.map((member, i) =>
          <div
            key={i}
            onClick={() => setExpanded(expanded === i ? null : i)}
            style={{
              position: 'relative',
              cursor: 'pointer',
              overflow: 'hidden',
              background: '#050A12'
            }}>
            
              {/* Photo */}
              <div style={{ position: 'relative', paddingTop: '120%', overflow: 'hidden' }}>
                <img
                src={member?.img}
                alt={member?.alt}
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  filter: 'grayscale(30%) brightness(0.7)',
                  transition: 'transform 400ms ease, filter 400ms ease',
                  transform: expanded === i ? 'scale(1.05)' : 'scale(1)'
                }} />
              
                {/* Gradient overlay */}
                <div style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(to top, rgba(5,10,18,0.95) 0%, rgba(5,10,18,0.3) 50%, transparent 100%)'
              }} />

                {/* Location tag */}
                <div style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.625rem',
                color: '#3B6FD4',
                letterSpacing: '0.15em',
                background: 'rgba(5,10,18,0.8)',
                padding: '4px 8px',
                border: '1px solid rgba(59,111,212,0.3)'
              }}>{member?.tag}</div>

                {/* Name/role overlay */}
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '24px' }}>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.125rem', fontWeight: 800, color: '#EEF0F2', letterSpacing: '-0.02em' }}>{member?.name}</div>
                  <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6875rem', color: '#3B6FD4', letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: '4px' }}>{member?.role}</div>
                </div>
              </div>

              {/* Expandable bio */}
              <div style={{
              maxHeight: expanded === i ? '200px' : '0',
              overflow: 'hidden',
              transition: 'max-height 400ms ease',
              background: 'rgba(59,111,212,0.08)',
              borderTop: expanded === i ? '1px solid rgba(59,111,212,0.2)' : 'none'
            }}>
                <p style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.875rem',
                color: 'rgba(238,240,242,0.7)',
                lineHeight: 1.7,
                padding: '20px 24px'
              }}>{member?.bio}</p>
              </div>
            </div>
          )}
        </div>

        <div style={{ marginTop: '16px', textAlign: 'center', fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6875rem', color: 'rgba(138,149,163,0.4)', letterSpacing: '0.1em' }}>
          KLIKK PÅ ET TEAMMEDLEM FOR Å LESE MER
        </div>
      </div>
    </section>);

};

export default TeamSection;